import { render } from "./FundPerformance.vue?vue&type=template&id=04e1a67d"
import script from "./FundPerformance.vue?vue&type=script&lang=js"
export * from "./FundPerformance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__